import type { CaseStatus } from "@dearbill/shared";
// The `Badge` component's tone union comes from its subpath, because the barrel
// exports the six-tone `BadgeTone` from lib/format under the same name (see the
// note in shared/src/index.ts).
import type { BadgeTone } from "@dearbill/shared/components/Badge";

/**
 * Presentational styling for the partner case status: the `Badge` tone and the
 * surface/text classes per status. The status itself arrives on the wire
 * (`caseStatus`, `caseStatusDetail` and `programStatus` on the partner
 * enrollment models), derived in server/app/services/case_status.py.
 */

/**
 * Each case status's `Badge` tone, which carries the pill's icon and the
 * Actions-needed dot color. New and Closed both map to `neutral`; their
 * distinct surfaces come from `CASE_STATUS_CHIP_CLASS`.
 */
export const CASE_STATUS_TONE: Record<CaseStatus, BadgeTone> = {
  New: "neutral",
  "In progress": "pending",
  Engaged: "active",
  "Needs attention": "error",
  Closed: "neutral",
};

/**
 * Surface and text classes per status, shared by the status pills, the Home
 * stat tiles and the Referrals filter chips. New reads as fresh (the stronger
 * Frost surface) and Closed as archived (a white, bordered, slate-teal
 * treatment), so the two never look alike. The color never carries meaning by
 * itself; the label is always present.
 */
export const CASE_STATUS_CHIP_CLASS: Record<CaseStatus, string> = {
  New: "bg-frost text-deep-navy",
  "In progress": "bg-lemon text-ochre",
  Engaged: "bg-mint text-forest",
  "Needs attention": "bg-pale-red text-error-red",
  Closed: "border-border-strong text-slate-teal border bg-white",
};
